import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import DiagnosticoAposentadoriaChart from '../estudo-chart/DiagnosticoAposentadoriaChart'



const EstudoReportDiagnosticoAposentadoriaChart = ({ values, handleChange, setFieldValue, estudo, report }) => {

    return (
        <>
            <DiagnosticoAposentadoriaChart
                values={values}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
                estudo={estudo}
                tipoDiagnosticoAposentadoriaChart={HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoAtual}
                report={report}
            />

            {values.valorPresenteDeficitSimulacaoMensal !== 0
                ?
                    <div
                        className='mt-5'
                    >
                        <DiagnosticoAposentadoriaChart
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            estudo={estudo}
                            tipoDiagnosticoAposentadoriaChart={HARDCODE.tipoDiagnosticoAposentadoriaChartSituacaoIdeal}
                            report={report}
                        />
                    </div>
                :
                    ''
            }
        </>
    )
}

export default EstudoReportDiagnosticoAposentadoriaChart